// extracted by mini-css-extract-plugin
module.exports = {"wrapper_empty":"Empty_wrapper_empty__t6-Q2","title":"Empty_title__1d28n","subTitle":"Empty_subTitle__9fQme","mobile":"Empty_mobile__VHYUL"};